export const voiceToneOptions = ["Default voices"];
export const AvatarsGender = ["Female", "Male"];
export const avatarStyleOptions = ["Blank", "Background"];
export enum AvatarModalType {
  Avatar = 1,
  Style,
}

export enum VideoDetailsView {
  history = 1,
  library,
}
